import $ from "jquery";
import { modal } from "../components/modal";
import { cloneableFactory } from "../components/cloneable";
import { ButtonSpinner } from "./buttonSpinner";
import { dialogs } from "../components/dialogs";
import { EventEmitter } from "../events/eventEmitter";
import { ajax } from "./ajax";
class AjaxForm extends EventEmitter {
    constructor(form) {
        super();
        $(form).on("submit", (e) => this.formFetch(e));
    }
    async formFetch(e) {
        e.preventDefault();
        const target = $(e.target);
        const url = target.attr("action");
        const title = target.data("ajax-confirmation-title");
        const message = target.data("ajax-confirmation-message");
        const showModal = target.is("[data-ajax-show-modal]");
        const blockUi = target.is("[data-ajax-block-ui]");
        const multipart = target.is("[data-ajax-multipart]");
        if (this.predicate && !(await this.predicate()))
            return;
        if (message) {
            const response = await dialogs.showDialog("confirmation", { message, title });
            if (response.result === "negative")
                return;
        }
        const buttonSpinner = new ButtonSpinner(e);
        buttonSpinner.show();
        const response = await ajax({
            url,
            form: target,
            showModal,
            blockUi,
            multipart,
        });
        if (response.success) {
            this.emit("success", response.data);
        }
        else {
            this.emit("failure", response.data, response.message);
        }
        buttonSpinner.hide();
    }
}
class AjaxFormFactory {
    initialise(container) {
        const forms = $(container).find("[data-ajax-form]");
        forms.toArray().forEach((f) => {
            const form = $(f);
            if (!form.data("ajax-form-model")) {
                const ajaxForm = new AjaxForm(form);
                form.data("ajax-form-model", ajaxForm);
            }
        });
    }
    getModels(forms) {
        return forms
            .toArray()
            .map((f) => $(f).data("ajax-form-model"))
            .filter((m) => !!m);
    }
}
export const ajaxFormFactory = new AjaxFormFactory();
modal.on("show", (m) => ajaxFormFactory.initialise(m));
cloneableFactory.on("itemAdded", (r) => ajaxFormFactory.initialise(r));
$(() => ajaxFormFactory.initialise(document));
